import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  equipmentConfigurations,
  equipmentConfigurationsForm,
  instalations,
  instalationsForm,
  projects,
  projectsForm,
  imputHours,
  imputHoursForm,
  singUps,
  singUpsForm,
  equipments,
  equipmentsForm,
  navUsers,
  incidences,
  incidencesForm,
  satisfactions,
  satisfactionsForm,
  alerts,
  alertsForm,
  shopCarts,
  shopCartsForm,
  articles,
  securitySheets,
  securitySheetsForm,
  invoices,
  deliveryNotes,
  downloadDocuments,
  signForm,
  repartidors,
  repartiments,
  suggestions,
  suggestionsForm,
  establishmentInfo,
  establishmentInfoForm,
  tags,
  tagsForm,
  expenses,
  expensesForm,
  OPCUA,
  OPCUAForm,
  timeRequests,
  timeRequestsForm,
  holidayRequests,
  holidayRequestsForm,
  workShifts,
  workShiftsForm,
  dosificationProducts,
  dosificationProductsForm,
  dosificationConfigs,
  dosificationConfigsForm,
  leaves,
  leavesForm,
  reasons,
  classrooms,
  reasonsForm,
  workOrders,
  workOrdersForm,
  products,
  rolesForm,
  roles,
  dosifications,
  dosificationsForm,
  raws,
  rawsForm,
  episForm,
  epis,
  allInstalations,
  allEquipments,
  currentTheme,
  stocks,
  stocksForm,
  bookings,
  bookingsForm,
  booktypes,
  booktypesForm,
  mailMessages,
  mailMessagesForm,
} from "./Reducers";

export default combineReducers({
  mailMessages,
  mailMessagesForm,
  booktypes,
  booktypesForm,
  bookings,
  bookingsForm,
  stocks,
  stocksForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  equipmentConfigurations,
  equipmentConfigurationsForm,
  instalations,
  instalationsForm,
  projects,
  projectsForm,
  imputHours,
  imputHoursForm,
  singUps,
  singUpsForm,
  equipments,
  equipmentsForm,
  navUsers,
  incidences,
  incidencesForm,
  satisfactions,
  satisfactionsForm,
  alerts,
  alertsForm,
  shopCarts,
  shopCartsForm,
  articles,
  securitySheets,
  securitySheetsForm,
  invoices,
  deliveryNotes,
  downloadDocuments,
  signForm,
  repartidors,
  repartiments,
  suggestions,
  suggestionsForm,
  establishmentInfo,
  establishmentInfoForm,
  tags,
  tagsForm,
  expenses,
  expensesForm,
  OPCUA,
  OPCUAForm,
  timeRequests,
  timeRequestsForm,
  holidayRequests,
  holidayRequestsForm,
  workShifts,
  workShiftsForm,
  dosificationProducts,
  dosificationProductsForm,
  dosificationConfigs,
  dosificationConfigsForm,
  leaves,
  leavesForm,
  reasons,
  classrooms,
  reasonsForm,
  workOrders,
  workOrdersForm,
  products,
  rolesForm,
  roles,
  dosifications,
  dosificationsForm,
  raws,
  rawsForm,
  episForm,
  epis,
  allInstalations,
  allEquipments,
  currentTheme,
});
